<template>
  <div>
    <amplify-authenticator username-alias="email">
      <div>
<!--        <amplify-sign-out></amplify-sign-out>-->
      </div>
    </amplify-authenticator>
<!--    <button v-on:click="federatedSignIn('Facebook')">Open Facebook</button>-->

  </div>
</template>

<script>
// import {Auth} from 'aws-amplify';

export default {
  name: "login",
  components: {
  },
  methods : {
    // federatedSignIn(provider) {
    //   Auth.federatedSignIn({ provider });
    //   console.log(provider);
    //   <!--        <button onClick={() => Auth.federatedSignIn({provider: 'Facebook'})}>Open Facebook</button>-->
    //
    // }
  }
}
</script>

<style scoped>

</style>
